var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:_vm.icon ? 'mt-3' : 'mt-1',attrs:{"align":"center"}},[_c('v-col',{class:!_vm.icon ? 'px-1' : '',attrs:{"cols":"auto"}},[_c('v-img',{attrs:{"src":_vm.icon}})],1),_c('v-col',{staticClass:"px-0"},[_c('h2',[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }